import utils from './../../utils.js';

export default utils.generateNamespace({
    actions: [
        'SEND_EVENT',
        'SET_UP_SERVICE'
    ]
});



// WEBPACK FOOTER //
// ./src/store/modules/support/namespace.js